module.exports = __webpack_public_path__ + "media/promo/hochland/images/v3-0b2ba240d5a86b224f534167e8bc2a03.png";